import api from "@/config/api";
import _ from "lodash";
const path = "private/token"

export default {
  create: (formulartyp_key, gueltig_bis, ...ref_ids) => {
    let json = {
      formulartyp_key,
      gueltig_bis
    }

    _.flatten(ref_ids).forEach((ref_id, i) => {
      json[`ref_id_${i + 1}`] = ref_id
    })

    return api.post(`${path}`, json, { withCredentials: true })
  }
}
